export default defineNuxtRouteMiddleware(async (to) => {
  const { loggedIn, user } = useUserSession()

  if (to.path === '/login') {
    return
  }

  if (!loggedIn.value || !user.value) {
    return navigateTo(`/login?redirectTo=${to.path}`)
  }

  const requiredRole = to.meta.role as string | undefined
  if (requiredRole && user.value.role !== requiredRole) {
    return navigateTo('/')
  }

  const requiredPermission = to.meta.permission as string | undefined
  const requiredPermissions = to.meta.permissions as string[] | undefined

  if (requiredPermission || requiredPermissions?.length) {
    const { can, canAny } = usePermission()

    if (requiredPermission && !can(requiredPermission)) {
      return navigateTo('/')
    }

    if (requiredPermissions?.length) {
      const allowed = to.meta.permissionMatch === 'all'
        ? requiredPermissions.every(code => can(code))
        : canAny(requiredPermissions)

      if (!allowed) {
        return navigateTo('/')
      }
    }
  }
})
